import { useMutation, useQuery, useQueryClient } from 'react-query';
import axios from 'axios';
import { CompanyTerms } from '../models/companyTerms';

const apiUrl = process.env.REACT_APP_BASIX_API || '';

const getTerms = async (): Promise<CompanyTerms> => {
  const { data } = await axios.get(`${apiUrl}settings/Terms`);
  return data;
};

const useCompanyTerms = () => {
  const queryClient = useQueryClient();
  const query = useQuery('companyTerms', getTerms);

  const mutation = useMutation(
    (terms: CompanyTerms) => axios.post(`${apiUrl}settings/Terms`, terms),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('companyTerms');
      },
    },
  );

  return {
    ...query,
    terms: query.data,
    tryUpdate: mutation.mutateAsync,
    isSaving: mutation.isLoading,
  };
};

export default useCompanyTerms;
